export default "./src/client/components/auth/login/open-web/spid-button/img/spid-idp-teamsystemid.svg?712e7dbff03097c95bafcb0f39d2d7ba";